<template>
	<v-card 
		flat
		color="secondary"
		dark
		class="walletContainer"
	>
		<v-card-title primary class="title">
			My Wallet
			<v-spacer />
			Total {{ totalValue.toFixed(3) }} ETH
		</v-card-title>
		<v-container grid-list-xs pl-3>
			<v-layout wrap align-center>
				<v-flex v-if="metamaskAccount">
					<v-chip 
						color="white" 
						text-color="primary"
					>
						<v-avatar>
							<v-icon small>
								fas fa-wallet
							</v-icon>
						</v-avatar>
						{{ metamaskAccount }}
					</v-chip>
				</v-flex>

				<v-flex 
					v-if="metamaskAccount"
					xs1
				>
					<v-btn 
						flat 
						icon 
						color="white" 
						@click="loadWallet"
					>
						<v-icon>fas fa-sync-alt</v-icon>
					</v-btn>
				</v-flex>

				<v-flex 
					v-if="!metamaskAccount"
				>
					<span
						class="body-1"
					>
						Please use metamask to connect your wallet!
					</span>
				</v-flex>

				<v-flex 
					v-if="!metamaskAccount"
					xs3
				>
					<a
						class="meta-button"
						href="https://metamask.io/"
					>
						<img
							class="meta-button"
							src="@/assets/download-metamask.png"
							width="100%"
						>
					</a>
				</v-flex>
			</v-layout>
		</v-container>

			

		<!-- Wallet Recap Card -->
		<v-card
			flat
			dark
			color="secondary"
		>            
			<v-container>
				<v-layout
					v-for="(value, name) in wallet"
					:key="name"
					row
					text-capitalize
					subheading
				>
					Balance {{ value.name }}
					<v-spacer /> 
					{{ value.amount + " " + value.currency }}
				</v-layout>
			</v-container>
		</v-card>
		<!-- End Wallet Recap Card -->

		<!-- Tabs for Properties and Exchange -->
		<v-tabs
			v-model="tab"
			color="secondary"	 
			fixed-tabs 
			grow
		>
			<v-tabs-slider color="white" />
			<v-tab 
				v-for="item in items"
				:key="item"
			>
				{{ item }}
			</v-tab>
		</v-tabs>
		<!-- End Tabs -->

		<v-tabs-items 
			v-model="tab"
		>
			<v-tab-item
				v-for="item in items"
				:key="item"
			>
			
				<!-- Exchange Tab -->
				<div
					v-if="item === 'Exchange' && user.uid != 'gKfNrBT2Ijb4isqQp4VDnAofQoQ2'"
				>
					<!-- Buy and sell -->
					<exchange
						:re20Value="re20Value"
						:feeValue="feeValue"
						:exchangeAction="(amount) => onBuyButton(amount)"
					/>
					<exchange
						:re20Value="re20Value"
						:feeValue="feeValue"
						:exchangeAction="(amount) => setSale(amount)"
						:isBuy="false"
					/>
				
					<v-layout 
						v-if="user.uid == 'gKfNrBT2Ijb4isqQp4VDnAofQoQ2'"
						column
						wrap
					>
						<h2 style="margin-left: 3%">
							Fees:
						</h2>
						<v-data-table
							:items="fees"
							class="elevation-1"
							hide-actions
							hide-headers
						>
							<template v-slot:items="props">
								<td class="table">
									{{ props.item.name }}
								</td>
								<td 
									class="text-xs-right table"
								>
									{{ props.item.value }}
								</td>
							</template>
						</v-data-table>
					</v-layout>
				</div>
				<!-- End Exchange Tab -->

				<!-- Properies Tab -->
				<div
						v-if="item === 'Properties'"
				>
					<v-flex>
						<v-flex
							v-for="(estate, index) in estates"
							:key="index"
						>         
							<v-card
								flat
								color="primary"
								class="estateContainer"
								@click="selectEstate (estate)"
							>
								<v-container>
									<v-layout
										row
										align-center
									>
										<v-flex 
											d-flex 
											xs10 
											justify-center
											align-center
										>
											<img
												:src="estate.photos ? estate.photos[0] : require('../assets/estate-placeholder.jpg')" 
												class="estate-image"
											>
										</v-flex>
										<v-container>
											<v-layout >
												<h4 class="font-weight-bold">
												{{ estate.name }}
												</h4>
											</v-layout>
											<v-layout class="font-weight-light">
												Estate 
												<v-spacer />
												{{ estate.buy_cost }}
											</v-layout>
											<v-layout class="font-weight-light">
												Estate shares
												<v-spacer />
												10/10
											</v-layout>
											<v-layout class="font-weight-light">
												Estate total cost 
												<v-spacer />
												{{ estate.buy_cost }}
											</v-layout>
											<v-layout class="font-weight-light">
												Annual cost 
												<v-spacer />
												100
											</v-layout>
											<v-layout class="font-weight-light">
												Activity 
												<v-spacer />
												0.000
											</v-layout>
										</v-container>
									</v-layout>
								</v-container>
							</v-card>
						</v-flex>
					</v-flex>
				</div>
				<!-- End Properies Tab -->
			
			</v-tab-item>
		</v-tabs-items>
	</v-card>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import firebase, { firestore } from 'firebase'
import { constants } from 'fs'
import web3 from '../plugins/web3'

export default {
	props: ['estates'],
	data () {
		return {
			tab: null,
			amount: null,
			feeValue: 0.2,
			re20Value: 0.001,
			items: ['Properties', 'Exchange', 'Account'],
		}
	},
	computed: {
		...mapGetters ([
			'tokenRE20'
		]),

		...mapState ({
			totalEths: state => state.wallet.totalEths,
			fees: state => state.wallet.fees,
			user: state => state.auth.user,
			value: state => state.wallet.totalEths,
			metamaskAccount: state => state.wallet.defaultAccount,
			buyEstatesQueue: state => state.wallet.buyEstatesQueue,
			buyRE20Queue: state => state.wallet.buyRE20Queue,
			token721: state => state.wallet.token721,
			ethValue: state => state.ethereum.ethValue
		}),

		ethAmount () {
			return this.amount * this.re20Value
		},
		
		feeAmount () {
			return (this.ethAmount * this.feeValue) / 100 
		},

		totalAmount () {
			return this.ethAmount + this.feeAmount
		},

		totalValue () {
			return parseFloat (this.wallet.BalanceETH.amount + this.wallet.BalanceRE20.amount + this.wallet.BalanceRE721.amount)
		},

		estatesValue () {
			var estateValue = 0
			for (var estate in this.estates) {
				estateValue += estate.buy_cost
			}
			return estateValue
		},

		wallet () {
			return {
				BalanceETH: {
					name: 'ETH',
					amount: parseFloat(this.totalEths).toFixed(3),
					currency: 'ETH'
				},
				BalanceRE20: {
					name: 'RE20',
					amount: this.tokenRE20,
					currency: 'RE20'
				},
				BalanceRE721: {
					name: 'RE721',
					amount: this.token721,
					currency: 'RE721'
				}
			}
		}
	},
	created () {
		this.loadWallet ()
		// If admin ->
		this.startListeningTransactions ()
	}, 
	methods: {
		...mapMutations (['showBuyToken', 'selectEstate', 'SHOW_ALERT', 'showLoader']),
		...mapActions (['loadWallet', 'approveAddress', 'transferEstateOwnership', 'transferRE20', 'buyRE20']),
		startListeningTransactions () {

			firebase.database ().ref ('transactions')
				.on ('child_added', child => {
					const transaction = child.val ()
					if (this.metamaskAccount && transaction.owner.toLowerCase () == this.metamaskAccount.toLowerCase ()) {
						console.log ('Request for a new transaction -> ', transaction, this.metamaskAccount)

						this.SHOW_ALERT ({
							text: 'New transaction request',
							message: `New transaction request from: ${transaction.from}.<br>Amount: ${transaction.tokens} RE20<br>Estate token id: ${transaction.token_id}.<br>Do you want to accept the transaction?`,
							dismissable: false,
							actions: [
								{
									text: 'Yes',
									handler: () => {
										if (!transaction.token_id || !transaction.from) {
											console.log ('Wrong data')
											return
										}

										this.approveAddress ({
											address: transaction.from,
											token: transaction.token_id,
											tokens: transaction.tokens
										})

										child.ref.remove ()
										this.showLoader (true)
									},
									type: 'success'
								},
								{
									text: 'Deny',
									handler: () => {
										child.ref.remove ()
										console.log ('deny')
									},
									type: 'error'
								}
							]
						})
					}
				})

			firebase.database ().ref ('approved_transactions')
				.on ('child_added', child => {
					const estate = child.val ()
					console.log ('Approved a new estate transaction -> ', estate)
					if (this.buyEstatesQueue.filter (queueEstate => queueEstate.token_id === estate.token_id).length > 0) {
						this.transferEstateOwnership (estate)
						child.ref.remove ()
					}
				})
		},

		onBuyButton (amount) {
				if (!amount) { 
				this.SHOW_ALERT ({
							text: 'Error',
							message: 'Insert a valid amount in the RE20 field',
							dismissable: true,
							actions: []
						})
				} 
				else {
					this.buyRE20 ('' + amount * this.re20Value)
				} 
		},

		setSale (amount) {
			console.log ("Sale is not available")
		}
	},
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.walletContainer {
	border: 1px solid white !important;
	overflow-y: scroll;
	overflow-x: hidden;
	min-height: 650px;
	max-height: 650px;
}

.estateContainer {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
																	supported by Chrome and Opera */
																	
	cursor: pointer;			
	border: 2px solid $secondary !important; 
  transition: border .3s;

	&:hover {
		border: 1px solid white !important; 
	}
}

.table {
	background-color: $secondary;
}

.estate-image {
	height: auto; 
  width: auto; 
  max-width: 200px; 
  max-height: 200px;
}
</style>

